<div class="custom-row">
  @if(mode === "read" && leadStatus !== approvedStatus && !(entry === 'referral' && (leadStatus === 'Review Complete' || leadStatus === deniedStatus)) && !readOnly && showEdit){
    <ppl-button 
    label="Edit" 
    icon="fa fa-pencil" 
    [customClass]="'ghost-button'" 
    [iconPosition]="'left'"
    (click)="doMfa()"
    *authorize="[pageId, tabId, 'Demographics', 'section', 'edit']"
    ></ppl-button>    
  <!-- <span (click)="editPersonalInfo()" nz-icon nzType="edit" nzTheme="outline"
    *authorize="[pageId, tabId, 'Demographics', 'section', 'edit']"></span> -->
  }

</div>
@if(mode==="edit"){
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="infoForm" class="ppl-p0">
    @if(isAttrAvailable('businessName')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label nzFor="businessName" [nzSm]="8" [nzXs]="24" class="ppl-form-label">{{ getAttributes("businessName").label }}
            @if(getAttributes('businessName').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <input nz-tooltip nzTooltipTitle="{{ getAttributes('businessName').tooltip }}" nzTooltipPlacement="topRight"
              nz-input formControlName="businessName" nzId="businessName" id="businessName"
              [authorizeField]="[pageId, tabId, 'Demographics', 'businessName']" placeholder="{{ getAttributes('businessName').placeholder }}"
              [ngClass]="{'error': validationErrors['businessName'] }" [attr.aria-invalid]="validationErrors['businessName'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['businessName'] ? 'businessName-error' : null" />
            @if (validationErrors['businessName']) {
            <span class="pl-1 error-message" id="businessName-error" role="alert">{{validationErrors['businessName']}}</span>
            }
  
          </nz-form-control>
        </nz-row>
  
      </nz-form-item>
      }
    @if(isAttrAvailable('fname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fname" class="ppl-form-label">{{getAttributes('fname').label}}
          @if(getAttributes('fname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="fname" id="fname" placeholder="{{getAttributes('fname').placeholder}}"
              [ngClass]="{'error': validationErrors['fname'] }" 
              [authorizeField]="[pageId, tabId, 'Demographics', 'fname']"
              [attr.aria-invalid]="validationErrors['fname'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['fname'] ? 'fname-error' : null"/>
          </div>
          @if (validationErrors['fname']) {
          <span class="pl-1 error-message" id="fname-error" role="alert">{{validationErrors['fname']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('mname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mname" class="ppl-form-label">{{ getAttributes("mname").label }}
          @if(getAttributes('mname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('mname').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="mname" nzId="mname" id="mname"
            [authorizeField]="[pageId, tabId, 'Demographics', 'mname']" placeholder="{{ getAttributes('mname').placeholder }}"
            [ngClass]="{'error': validationErrors['mname'] }"
            [attr.aria-invalid]="validationErrors['mname'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['mname'] ? 'mname-error' : null" />
          @if (validationErrors['mname']) {
          <span class="pl-1 error-message" id="mname-error" role="alert">{{validationErrors['mname']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('lname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lname" class="ppl-form-label">{{ getAttributes("lname").label }}
          @if(getAttributes('lname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''" nzTooltipPlacement="topRight">
          <input
            nz-input formControlName="lname" id="lname"
            [authorizeField]="[pageId, tabId, 'Demographics', 'lname']" placeholder="{{ getAttributes('lname').placeholder }}"
            [ngClass]="{'error': validationErrors['lname'] }"
            [attr.aria-invalid]="validationErrors['lname'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['lname'] ? 'lname-error' : null" />
              </div>
          @if (validationErrors['lname']) {
          <span class="pl-1 error-message" id="lname-error" role="alert">{{validationErrors['lname']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>} @if(isAttrAvailable('maiden_name')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="maiden_name">{{
          getAttributes("maiden_name").label }}
          @if(getAttributes('maiden_name').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('maiden_name').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="maiden_name" nzId="maiden_name" id="maiden_name"
            [authorizeField]="[pageId, tabId, 'Demographics', 'maiden_name']"
            placeholder="{{ getAttributes('maiden_name').placeholder }}"
            [ngClass]="{'error': validationErrors['maiden_name'] }"
            [attr.aria-invalid]="validationErrors['maiden_name'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['maiden_name'] ? 'maiden_name-error' : null" />
          @if (validationErrors['maiden_name']) {
          <span class="pl-1 error-message" id="maiden_name-error" role="alert">{{validationErrors['maiden_name']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('dob')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dob" class="ppl-form-label">{{ getAttributes("dob").label }}
          @if(getAttributes('dob').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control nzSpan="24" class="ppl-form-control">
          <!-- <nz-date-picker nzSpan="24" formControlName="dob" nzId="dob" nz-tooltip [nzAllowClear]="false"
            [authorizeField]="[pageId, tabId, 'Demographics', 'dob']" nzTooltipTitle="{{ getAttributes('dob').tooltip }}"
            nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('dob').placeholder"
            [ngClass]="{'error': validationErrors['dob'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
          <ppl-date-picker formControlName="dob" id="dob" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'dob']"
          [placeholder]="getAttributes('dob').label" dateFormat="mm/dd/yy" [readonlyInput]="true"
          [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
          inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
          [ariaLabel]="getAttributes('dob').mandatory === 'Y' 
                            ? getAttributes('dob').label + ', required' 
                            : getAttributes('dob').label"
          [styleClass]="validationErrors['dob'] ? 'error' : ''" [attr.aria-invalid]="validationErrors['dob'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['dob'] ? 'dob-error' : null">
          </ppl-date-picker>
          @if (validationErrors['dob']) {
          <span class="pl-1 error-message" id="dob-error" role="alert">{{validationErrors['dob']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>} @if(isAttrAvailable('gender')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="gender" [authorizeField]="[pageId, tabId, 'Demographics', 'gender']"
          class="ppl-form-label">{{ getAttributes("gender").label }}
          @if(getAttributes('gender').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left">
          <!-- <nz-radio-group
          nz-tooltip
          nzTooltipTitle="{{ getAttributes('gender').tooltip }}"
          nzTooltipPlacement="topRight"
          formControlName="gender"
          class="ppl-radio-group"
          nzId="gender"
        >

        @for(opt of genderList; track $index){
          <label nz-radio-button [nzValue]="opt.lkpValueCode">{{opt.lkpValueName}}</label>
          }
        </nz-radio-group> -->
          <div [ngClass]="{'error': validationErrors['gender'] }">
            <ppl-dropdown-select formControlName="gender" id="gender" [arialabel]="'Gender'" [placeholder]="'Select Gender'"
            [options]="genderList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>}
    @if(isAttrAvailable('state')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="state" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'state']">{{ getAttributes("state").label }}
          @if(getAttributes('state').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('state').tooltip}}">
          <div [ngClass]="{'error': validationErrors['state'] }">
            <ppl-dropdown-select formControlName="state" id="state"
            [options]="statesList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
            [attr.aria-invalid]="validationErrors['state'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['state'] ? 'state-error' : null"
          [arialabel]="getAttributes('state').mandatory === 'Y' 
                                ? 'State of application, required' 
                                : 'State of application'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['state']) {
          <span class="pl-1 error-message" id="state-error" role="alert">{{validationErrors['state']}}</span>
          }
        </nz-form-control>
        
      </nz-row>

    </nz-form-item>
    }
    @if(isAttrAvailable('relationToParticipant')){
      <!-- <div nz-col [nzSm]="6" [nzXs]="24"> -->
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24"  zFor="relationToParticipant"
            class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
            @if(getAttributes('relationToParticipant').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control  class="ppl-form-control" nz-tooltip
            nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}" nzLabelAlign="left">
            <div [ngClass]="{'error': validationErrors['relationToParticipant'] }">
              <ppl-dropdown-select formControlName="relationToParticipant"
              [id]="'relationToParticipant' + sectionName" placeholder="Select relation to Consumer"
              [options]="relationshipOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [arialabel]="getAttributes('relationToParticipant').mandatory === 'Y' 
                                ? getAttributes('relationToParticipant').label + ', required' 
                                : getAttributes('relationToParticipant').label"
              [attr.aria-invalid]="validationErrors['relationToParticipant'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['relationToParticipant'] ? 'relationToParticipant-error' : null">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['relationToParticipant']) {
            <span class="pl-1 error-message" id="relationToParticipant-error" role="alert">{{validationErrors['relationToParticipant']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
      <!-- </div> -->
      }

      @if(isAttrAvailable('tempProtectedSts')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" zFor="tempProtectedSts" class="ppl-form-label">{{getAttributes('tempProtectedSts').label}}
            @if(getAttributes('tempProtectedSts').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('tempProtectedSts').tooltip}}"
            nzLabelAlign="left">
            <div [ngClass]="{'error': validationErrors['tempProtectedSts'] }">
              <ppl-dropdown-select formControlName="tempProtectedSts" [id]="'tempProtectedSts' + sectionName" placeholder="Temporary Protected Status"
                [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'" [arialabel]="getAttributes('tempProtectedSts').mandatory === 'Y' 
                                        ? getAttributes('tempProtectedSts').label + ', required' 
                                        : getAttributes('tempProtectedSts').label"
                [attr.aria-invalid]="validationErrors['tempProtectedSts'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['tempProtectedSts'] ? 'tempProtectedSts-error' : null">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['tempProtectedSts']) {
            <span class="pl-1 error-message" id="tempProtectedSts-error" role="alert">{{validationErrors['tempProtectedSts']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }
      @if(infoForm.get('tempProtectedSts')?.value === 'Yes') {
      @if(isAttrAvailable('tpsCountryLkp')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" zFor="tpsCountryLkp"
            class="ppl-form-label">{{getAttributes('tpsCountryLkp').label}}
            @if(getAttributes('tpsCountryLkp').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('tpsCountryLkp').tooltip}}"
            nzLabelAlign="left">
            <div [ngClass]="{'error': validationErrors['tpsCountryLkp'] }">
              <ppl-dropdown-select formControlName="tpsCountryLkp" [id]="'tpsCountryLkp' + sectionName" placeholder="TPS Country"
                [options]="tpsCountries" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [arialabel]="getAttributes('tpsCountryLkp').mandatory === 'Y' 
                                        ? getAttributes('tpsCountryLkp').label + ', required' 
                                        : getAttributes('tpsCountryLkp').label"
                [attr.aria-invalid]="validationErrors['tpsCountryLkp'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['tpsCountryLkp'] ? 'tpsCountryLkp-error' : null">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['tpsCountryLkp']) {
            <span class="pl-1 error-message" id="tpsCountryLkp-error" role="alert">{{validationErrors['tpsCountryLkp']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }
      }

      @if(isAttrAvailable('nonProfitStatus')){
        <nz-form-label [nzSpan]="24" nzFor="nonProfitStatus" class="ppl-form-label"
          style="margin:0 0 0 16px;">{{getAttributes('nonProfitStatus').label}}
          @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
          <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="taxExempt"
                class="ppl-form-label">{{getAttributes('taxExempt').label}}
                @if(getAttributes('taxExempt').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }</nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div [ngClass]="{'error': validationErrors['taxExempt'] }">
                  <ppl-dropdown-select formControlName="taxExempt" [id]="'taxExempt' + sectionName"
                  placeholder="{{getAttributes('taxExempt').placeholder}}"
                  [options]="taxExemptOptions" [optionLabel]="'lkpValueName'" optionValue="'lkpValueCode'"
                  [attr.aria-invalid]="validationErrors['taxExempt'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['taxExempt'] ? 'taxExempt-error' : null">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['taxExempt']) {
                <span class="pl-1 error-message" id="taxExempt-error" role="alert">{{validationErrors['taxExempt']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
      
        
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nprftDocumentationReceived"
                class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
                @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }</nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div style="width:100%; margin-bottom: 16px" [ngClass]="{'error': validationErrors['nprftDocumentationReceived'] }">
                  <ppl-dropdown-select formControlName="nprftDocumentationReceived" id="nprftDocumentationReceived"
                  placeholder="{{getAttributes('nprftDocumentationReceived').placeholder}}" [options]="nprftDocumentationReceivedOptions" [optionLabel]="'label'" [optionValue]="'value'"
                  [attr.aria-invalid]="validationErrors['nprftDocumentationReceived'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['nprftDocumentationReceived'] ? 'nprftDocumentationReceived-error' : null">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['nprftDocumentationReceived']) {
                <span class="pl-1 error-message" id="nprftDocumentationReceived-error" role="alert">{{validationErrors['nprftDocumentationReceived']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
        }
      @if(isAttrAvailable('isShowOnDirectory')){
        <nz-form-item nz-col nzSpan="16" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isShowOnDirectory" [authorizeField]="[pageId, tabId, 'Demographics', 'isShowOnDirectory']"
            class="ppl-form-label">{{getAttributes('isShowOnDirectory').label}}
            @if(getAttributes('isShowOnDirectory').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }
          </nz-form-label>
          <nz-form-control  class="ppl-form-control"  [nzSm]="6" [nzXs]="24" nz-tooltip
          nzTooltipTitle="{{getAttributes('isShowOnDirectory').tooltip}}" nzLabelAlign="left">
              <div [ngClass]="{'error': validationErrors['isShowOnDirectory'] }">
                <ppl-dropdown-select formControlName="isShowOnDirectory" [id]="'isShowOnDirectory'  + sectionName"
                [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'"
                [attr.aria-invalid]="validationErrors['isShowOnDirectory'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isShowOnDirectory'] ? 'isShowOnDirectory-error' : null">
                </ppl-dropdown-select>
              </div>
              <!-- <nz-radio-group [ngClass]="{'error': validationErrors['isShowOnDirectory'] }" nz-tooltip [nzTooltipTitle]="getAttributes('isShowOnDirectory')?.tooltip || ''"
              nzTooltipPlacement="topRight" formControlName="isShowOnDirectory" class="ppl-radio-group" nzId="isShowOnDirectory"  nzLabelAlign="left">
                @for(opt of radioOptions; track $index){
                  <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                }
              </nz-radio-group> -->
            @if (validationErrors['isShowOnDirectory']) {
            <span class="pl-1 error-message" id="isShowOnDirectory-error" role="alert">{{validationErrors['isShowOnDirectory']}}</span>
            }
          </nz-form-control>
          </nz-row>
          
        </nz-form-item>
        }

        @if(isAttrAvailable('isProvidingServices')){
          <nz-form-item nz-col nzSpan="16" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isProvidingServices" [authorizeField]="[pageId, tabId, 'Demographics', 'isProvidingServices']"
              class="ppl-form-label">{{getAttributes('isProvidingServices').label}}
              @if(getAttributes('isProvidingServices').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </nz-form-label>
            <nz-form-control class="ppl-form-control"  [nzSm]="6" [nzXs]="24" nz-tooltip
            nzTooltipTitle="{{getAttributes('isProvidingServices').tooltip}}" nzLabelAlign="left">
              <div [ngClass]="{'error': validationErrors['isProvidingServices'] }">
                <ppl-dropdown-select formControlName="isProvidingServices" [id]="'isProvidingServices'  + sectionName"
                [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'"
                [attr.aria-invalid]="validationErrors['isProvidingServices'] ? 'true' : 'false'"
                [arialabel]="getAttributes('isProvidingServices')?.ariaLabel || getAttributes('isProvidingServices')?.label"
                [attr.aria-label]="getAttributes('isProvidingServices')?.ariaLabel || getAttributes('isProvidingServices')?.label"
                [attr.aria-describedby]="validationErrors['isProvidingServices'] ? 'isProvidingServices-error' : null">
                </ppl-dropdown-select>
              </div>
                <!-- <nz-radio-group [ngClass]="{'error': validationErrors['isProvidingServices'] }" nz-tooltip [nzTooltipTitle]="getAttributes('isProvidingServices')?.tooltip || ''"
                nzTooltipPlacement="topRight" formControlName="isProvidingServices" class="ppl-radio-group" nzId="isProvidingServices"  nzLabelAlign="left">
                  @for(opt of radioOptions; track $index){
                    <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                  }
                </nz-radio-group> -->
              @if (validationErrors['isProvidingServices']) {
              <span class="pl-1 error-message" id="isProvidingServices-error" role="alert">{{validationErrors['isProvidingServices']}}</span>
              }
            </nz-form-control>
            </nz-row>
            
          </nz-form-item>
          }

          @if(isAttrAvailable('yearsInState')){
            <nz-form-item nz-col nzSpan="16" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="yearsInState" [authorizeField]="[pageId, tabId, 'Demographics', 'yearsInState']"
                class="ppl-form-label">{{getAttributes('yearsInState').label}}
                @if(getAttributes('yearsInState').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control"  [nzSm]="6" [nzXs]="24" nz-tooltip
              nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}" nzLabelAlign="left">
              <input nz-tooltip nzTooltipTitle="{{ getAttributes('yearsInState').tooltip }}" nzTooltipPlacement="topRight"
              nz-input formControlName="yearsInState" nzId="yearsInState" id="yearsInState"
              [authorizeField]="[pageId, tabId, 'Demographics', 'yearsInState']"
              placeholder="{{ getAttributes('yearsInState').placeholder }}"
              [ngClass]="{'error': validationErrors['yearsInState'] }" [attr.aria-invalid]="validationErrors['yearsInState'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['yearsInState'] ? 'yearsInState-error' : null" />
                @if (validationErrors['yearsInState']) {
                <span class="pl-1 error-message" id="yearsInState-error" role="alert">{{validationErrors['yearsInState']}}</span>
                }
              </nz-form-control>
              </nz-row>
              
            </nz-form-item>
            }
    @if(isAttrAvailable('additionalDemographics')){
      
      <nz-divider></nz-divider>
        <nz-form-label [nzSpan]="24" [nzXs]="24" nzFor="additionalDemographics" class="ppl-form-label"
          style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
          @if(getAttributes('additionalDemographics').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
     
          @if(isAttrAvailable('race')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
          <nz-row> 
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="race" class="ppl-form-label">{{getAttributes('race').label}}
                @if(getAttributes('race').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip
                nzTooltipTitle="{{getAttributes('race').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['race'] }">
            <ppl-dropdown-select formControlName="race" [id]="'race'  + sectionName"
            [options]="raceOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
            [attr.aria-invalid]="validationErrors['race'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['race'] ? 'race-error' : null">
            </ppl-dropdown-select>
          </div>
                
                @if (validationErrors['race']) {
                <span class="pl-1 error-message" id="race-error" role="alert">{{validationErrors['race']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
          }
          @if(isAttrAvailable('height')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row> 
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="height" class="ppl-form-label">{{getAttributes('height').label}}
                @if(getAttributes('height').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('height')?.tooltip || ''" nzTooltipPlacement="topRight"
                  class="height-input-container ppl-form-control">
                  <nz-row [nzGutter]="16">
                    <nz-col [nzSm]="12" [nzXs]="24">
                      <input nz-input formControlName="heightFeet" [id]="'heightFeet'  + sectionName" placeholder="Feet"
                        [ngClass]="{'error': validationErrors['heightFeet']}" [attr.aria-invalid]="validationErrors['heightFeet'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['heightFeet'] ? 'heightFeet-error' : null" />
                        @if (validationErrors['heightFeet']) {
                          <span class="pl-1 error-message" id="heightFeet-error" role="alert">{{validationErrors['heightFeet']}}</span>
                          }
                    </nz-col>
                    <nz-col [nzSm]="12" [nzXs]="24">
                      <input nz-input formControlName="heightInches" [id]="'heightInches'  + sectionName" placeholder="Inches"
                        [ngClass]="{'error': validationErrors['heightInches']}" [attr.aria-invalid]="validationErrors['heightInches'] ? 'true' : 'false'"
                        [attr.aria-describedby]="validationErrors['heightInches'] ? 'heightInches-error' : null" />
                        @if  (validationErrors['heightInches']) {
                        <span class="pl-1 error-message" id="heightInches-error" role="alert">{{validationErrors['heightInches']}}</span>
                        }
                      </nz-col>
                  </nz-row>
                </div>
              </nz-form-control>
            </nz-row>
            </nz-form-item>
         
          }
          @if(isAttrAvailable('weight')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="weight" class="ppl-form-label">
                  {{getAttributes('weight').label}}
                  @if(getAttributes('weight').mandatory === 'Y'){
                  <span [attr.aria-label]="'Required'">*</span>
                  }
                </nz-form-label>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''" nzTooltipPlacement="topRight"
                    class="weight-input-container ppl-form-control">
                    <input nz-input formControlName="weight" [id]="'weight'  + sectionName"
                      placeholder="{{getAttributes('weight').placeholder}}" [ngClass]="{'error': validationErrors['weight']}"
                      [attr.aria-invalid]="validationErrors['weight'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['weight'] ? 'weight-error' : null" />
                    <!-- <span class="unit-label">Pounds</span> -->
                  </div>
                  @if (validationErrors['weight']) {
                    <span class="pl-1 error-message" id="weight-error" role="alert">{{validationErrors['weight']}}</span>
                    }
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            }
            @if(isAttrAvailable('eyeColor')){
              <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                <nz-form-label  [nzSm]="8" [nzXs]="24" nzFor="eyeColor" class="ppl-form-label">{{getAttributes('eyeColor').label}}
                  @if(getAttributes('eyeColor').mandatory === 'Y'){
                  <span [attr.aria-label]="'Required'">*</span>
                  }
                </nz-form-label>
                <nz-form-control class="ppl-form-control" nz-tooltip
                  nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}" nzTooltipPlacement="topRight">
                  <div [ngClass]="{'error': validationErrors['eyeColor'] }">
                    <ppl-dropdown-select formControlName="eyeColor" [id]="'eyeColor'  + sectionName"
                    [options]="eyeColors" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                    [attr.aria-invalid]="validationErrors['eyeColor'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['eyeColor'] ? 'eyeColor-error' : null">
                    </ppl-dropdown-select>
                  </div>

                  @if (validationErrors['eyeColor']) {
                  <span class="pl-1 error-message" id="eyeColor-error" role="alert">{{validationErrors['eyeColor']}}</span>
                  }
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            }
          @if(isAttrAvailable('hairColor')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="hairColor" class="ppl-form-label">{{getAttributes('hairColor').label}}
                @if(getAttributes('hairColor').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip
                nzTooltipTitle="{{getAttributes('hairColor').tooltip}}" nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['hairColor'] }">
                  <ppl-dropdown-select formControlName="hairColor" [id]="'hairColor'  + sectionName"
                  [options]="hairColors" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                  [attr.aria-invalid]="validationErrors['hairColor'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['hairColor'] ? 'hairColor-error' : null">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['hairColor']) {
                <span class="pl-1 error-message" id="hairColor-error" role="alert">{{validationErrors['hairColor']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
          
          }
          @if(isAttrAvailable('birthPlace')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>

              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="birthPlace" class="ppl-form-label">{{getAttributes('birthPlace').label}}
                  @if(getAttributes('birthPlace').mandatory === 'Y'){
                  <span [attr.aria-label]="'Required'">*</span>
                  }
                </nz-form-label>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCity" [id]="'birthCity'  + sectionName" placeholder="City" />
                  </div>
                </nz-form-control>
                <nz-form-control  class="ppl-form-control" style="margin: 0px 4px;">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthState" [id]="'state'  + sectionName" placeholder="State" />
                  </div>
                </nz-form-control>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCountry" [id]="'country'  + sectionName" placeholder="Country" />
                  </div>
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            
            }
      }
    
        <!-- @if(isAttrAvailable('mobile')){
  
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
            <nz-row>
            <nz-form-label  [nzSm]="8" [nzXs]="24" nzFor="mobile" class="ppl-form-label"
              [ngStyle]="{ 'margin-bottom':'0' }">{{getAttributes('mobile').label}}
              @if(getAttributes('mobile').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </nz-form-label>
            <nz-form-control>
              <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}" nzTooltipPlacement="topRight"
                nz-input [id]="'mobile'" formControlName="mobile"
                [ngClass]="{'error': validationErrors['mobile'] }"
                placeholder="{{getAttributes('mobile').placeholder}}" />
              @if (validationErrors['mobile']) {
              <span class="pl-1 error-message">{{validationErrors['mobile']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        } -->
        @if(isAttrAvailable('registerPref')){
          <nz-form-item nz-col nzSpan="16" class="ppl-form-item nz-padding-left">
            <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="registerPref"
            class="ppl-form-label">{{getAttributes('registerPref').label}}
            @if(getAttributes('registerPref').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }
          </nz-form-label>
         
            <nz-form-control class="ppl-form-control" [nzSm]="6" [nzXs]="24"  nz-tooltip nzTooltipTitle="{{getAttributes('registerPref').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['registerPref'] }">
                <ppl-dropdown-select formControlName="registerPref" [id]="'registerPref'  + sectionName"
                [options]="participantRegisterMode" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [attr.aria-invalid]="validationErrors['registerPref'] ? 'true' : 'false'" [arialabel]="getAttributes('registerPref').label"
              [attr.aria-describedby]="validationErrors['registerPref'] ? 'registerPref-error' : null"></ppl-dropdown-select>
              </div>
              @if (validationErrors['registerPref']) {
              <span class="pl-1 error-message" id="registerPref-error" role="alert">{{validationErrors['registerPref']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>
        }
        
     
    @if(isAttrAvailable('waiver')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="waiver" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'waiver']">{{ getAttributes("waiver").label }}
          @if(getAttributes('waiver').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('waiver').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['waiver'] }">
            <ppl-dropdown-select formControlName="waiver" id="waiver" placeholder="Select Service Administration"
            [options]="waiver" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
            [attr.aria-invalid]="validationErrors['waiver'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['waiver'] ? 'waiver-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['waiver']) {
          <span class="pl-1 error-message" id="waiver-error" role="alert">{{validationErrors['waiver']}}</span>
          }
        </nz-form-control>
      </nz-row>
      </nz-form-item>
      }
      @if(isAttrAvailable('ldssOffice')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ldssOffice" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'ldssOffice']">{{ getAttributes("ldssOffice").label }}
            @if(getAttributes('ldssOffice').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('ldssOffice').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['ldssOffice'] }">
              <ppl-dropdown-select formControlName="ldssOffice" id="ldssOffice" placeholder="Select LDSS Office"
              [options]="ldssOfficeValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['ldssOffice'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['ldssOffice'] ? 'ldssOffice-error' : null">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['ldssOffice']) {
            <span class="pl-1 error-message" id="ldssOffice-error" role="alert">{{validationErrors['ldssOffice']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
        }
      @if(isAttrAvailable('mcoOrgName')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoOrgName" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'mcoOrgName']">{{ getAttributes("mcoOrgName").label }}
            @if(getAttributes('mcoOrgName').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['mcoOrgName'] }">
              <ppl-dropdown-select formControlName="mcoOrgName" id="mcoOrgName" placeholder="{{getAttributes('mcoOrgName').tooltip}}"
              [options]="mcoEntries" [optionLabel]="'orgName'" [optionValue]="'orgName'"
              [arialabel]="getAttributes('mcoOrgName').mandatory === 'Y' 
                                ? 'MCO, required' 
                                : 'MCO'"
              [attr.aria-invalid]="validationErrors['mcoOrgName'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['mcoOrgName'] ? 'mcoOrgName-error' : null">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['mcoOrgName']) {
            <span class="pl-1 error-message" id="mcoOrgName-error" role="alert">{{validationErrors['mcoOrgName']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('currentFI')){
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="currentFI" class="ppl-form-label"
              [authorizeField]="[pageId, tabId, 'Demographics', 'currentFI']">{{ getAttributes("currentFI").label }}
              @if(getAttributes('currentFI').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('currentFI').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['currentFI'] }">
                <ppl-dropdown-select formControlName="currentFI" id="currentFI" placeholder="Select current FI"
                [options]="currentFIValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [attr.aria-invalid]="validationErrors['currentFI'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['currentFI'] ? 'currentFI-error' : null">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['currentFI']) {
              <span class="pl-1 error-message" id="currentFI-error" role="alert">{{validationErrors['currentFI']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        }
        @if(isAttrAvailable('fiOrgName')){
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fiOrgName" class="ppl-form-label"
              [authorizeField]="[pageId, tabId, 'Demographics', 'fiOrgName']">{{ getAttributes("fiOrgName").label }}
              @if(getAttributes('fiOrgName').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['fiOrgName'] }">
                <ppl-dropdown-select formControlName="fiOrgName" id="fiOrgName" placeholder="{{getAttributes('fiOrgName').tooltip}}"
                [options]="fiEntries" [optionLabel]="'orgName'" [optionValue]="'orgName'"
                [attr.aria-invalid]="validationErrors['fiOrgName'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['fiOrgName'] ? 'fiOrgName-error' : null">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['fiOrgName']) {
              <span class="pl-1 error-message" id="fiOrgName-error" role="alert">{{validationErrors['fiOrgName']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        }
      @if(isAttrAvailable('eligiblityStartDate')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityStartDate" class="ppl-form-label">{{ getAttributes("eligiblityStartDate").label }}
              @if(getAttributes('eligiblityStartDate').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control nzSpan="24" class="ppl-form-control">
              <!-- <nz-date-picker nzSpan="24" formControlName="eligiblityStartDate" nzId="eligiblityStartDate" nz-tooltip
                [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityStartDate']" nzTooltipTitle="{{ getAttributes('eligiblityStartDate').tooltip }}"
                nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('eligiblityStartDate').placeholder"
                [ngClass]="{'error': validationErrors['eligiblityStartDate'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
              <ppl-date-picker formControlName="eligiblityStartDate" id="eligiblityStartDate" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityStartDate']"
              [placeholder]="getAttributes('eligiblityStartDate').placeholder" dateFormat="mm/dd/yy" [readonlyInput]="true"
              [ariaLabel]="getAttributes('eligiblityStartDate').label" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
              [styleClass]="validationErrors['eligiblityStartDate'] ? 'error' : ''"
              [attr.aria-invalid]="validationErrors['eligiblityStartDate'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['eligiblityStartDate'] ? 'eligiblityStartDate-error' : null"></ppl-date-picker>
              @if (validationErrors['eligiblityStartDate']) {
              <span class="pl-1 error-message" id="eligiblityStartDate-error" role="alert">{{validationErrors['eligiblityStartDate']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>}
      @if(isAttrAvailable('eligiblityEndDate')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityEndDate" class="ppl-form-label">{{ getAttributes("eligiblityEndDate").label }}
              @if(getAttributes('eligiblityEndDate').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control nzSpan="24" class="ppl-form-control">
              <!-- <nz-date-picker nzSpan="24" formControlName="eligiblityEndDate" nzId="eligiblityEndDate" nz-tooltip
                [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityEndDate']" nzTooltipTitle="{{ getAttributes('eligiblityEndDate').tooltip }}"
                nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('eligiblityEndDate').placeholder"
                [ngClass]="{'error': validationErrors['eligiblityEndDate'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
                <ppl-date-picker formControlName="eligiblityEndDate" id="eligiblityEndDate" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityEndDate']"
              [placeholder]="getAttributes('eligiblityEndDate').placeholder" dateFormat="mm/dd/yy" [readonlyInput]="true"
              [ariaLabel]="getAttributes('eligiblityEndDate').label" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
              [styleClass]="validationErrors['eligiblityEndDate'] ? 'error' : ''"
              [attr.aria-invalid]="validationErrors['eligiblityEndDate'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['eligiblityEndDate'] ? 'eligiblityEndDate-error' : null"></ppl-date-picker>
              @if (validationErrors['eligiblityEndDate']) {
              <span class="pl-1 error-message" id="eligiblityEndDate-error" role="alert">{{validationErrors['eligiblityStartDate']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>}
        @if(isAttrAvailable('contactStsReasonLkp')){
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsReasonLkp" class="ppl-form-label"
              [authorizeField]="[pageId, tabId, 'Demographics', 'contactStsReasonLkp']">{{ getAttributes("contactStsReasonLkp").label }}
              @if(getAttributes('contactStsReasonLkp').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('contactStsReasonLkp').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['contactStsReasonLkp'] }">
                <ppl-dropdown-select formControlName="contactStsReasonLkp" id="contactStsReasonLkp" placeholder="{{getAttributes('contactStsReasonLkp').tooltip}}"
                [options]="contactStsReasonLkpList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [attr.aria-invalid]="validationErrors['contactStsReasonLkp'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['contactStsReasonLkp'] ? 'contactStsReasonLkp-error' : null">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['contactStsReasonLkp']) {
              <span class="pl-1 error-message" id="contactStsReasonLkp-error" role="alert">{{validationErrors['contactStsReasonLkp']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        }
          @if(isAttrAvailable('contactStsComments')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsComments"
                class="ppl-form-label ">{{getAttributes('contactStsComments').label}}
                @if(getAttributes('contactStsComments').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('contactStsComments').tooltip}}"
                nzTooltipPlacement="topRight">
                <textarea rows="4" cols="40" nz-input formControlName="contactStsComments" id="contactStsComments" class="ppl-form-control"
                  placeholder="{{getAttributes('contactStsComments').placeholder}}"  [ngClass]="{'error': validationErrors['contactStsComments'] }"
                  [attr.aria-invalid]="validationErrors['contactStsComments'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['contactStsComments'] ? 'contactStsComments-error' : null"></textarea>
                  @if (validationErrors['contactStsComments']) {
                    <span class="pl-1 error-message"  id="contactStsComments-error" role="alert">{{validationErrors['contactStsComments']}}</span>
                  }
              </nz-form-control>
              
              </nz-row>

            </nz-form-item>
            }
            @if(isAttrAvailable('prospectiveDR') && entry === 'referral'){
              <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR" class="ppl-form-label"
                    [authorizeField]="[pageId, tabId, 'Demographics', 'prospectiveDR']">{{getAttributes('prospectiveDR').label}}
                    @if(getAttributes('prospectiveDR').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control class="ppl-form-control">
                    <div class="height-input-container" nz-tooltip [nzTooltipTitle]="getAttributes('prospectiveDR')?.tooltip || ''" nzTooltipPlacement="topRight">
                      <div style="flex: 1;">
                        <input nz-input formControlName="pdrFirstName" [id]="'pdrFirstName' + sectionName" placeholder="First Name"
                          [ngClass]="{'error': validationErrors['pdrFirstName'] }" />
                        @if (validationErrors['pdrFirstName']) {
                        <span class="pl-1 error-message" id="pdrFirstName-error" role="alert">{{validationErrors['pdrFirstName']}}</span>
                        }
                      </div>
                      <div style="flex: 1;">
                        <input nz-input formControlName="pdrLastName" [id]="'pdrLastName' + sectionName" placeholder="Last Name"
                          [ngClass]="{'error': validationErrors['pdrLastName'] }" />
                        @if (validationErrors['pdrLastName']) {
                        <span class="pl-1 error-message" id="pdrLastName-error" role="alert">{{validationErrors['pdrLastName']}}</span>
                        }
                      </div>
                      <div style="flex: 1;" [ngClass]="{'error': validationErrors['pdrRelation'] }">
                        <ppl-dropdown-select formControlName="pdrRelation" [id]="'pdrRelation' + sectionName"
                          placeholder="Relationship" [options]="relationshipOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                          [attr.aria-invalid]="validationErrors['pdrRelation'] ? 'true' : 'false'">
                        </ppl-dropdown-select>
                        @if (validationErrors['pdrRelation']) {
                        <span class="pl-1 error-message" id="pdrRelation-error" role="alert">{{validationErrors['pdrRelation']}}</span>
                        }
                      </div>
                    </div>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
            }
            @if(isAttrAvailable('prospectiveDR') && entry === 'participantEnrollment'){
              <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR" class="ppl-form-label"
                    [authorizeField]="[pageId, tabId, 'Demographics', 'prospectiveDR']">{{getAttributes('prospectiveDR').label}}</nz-form-label>
                  <nz-form-control class="ppl-form-control">
                    <div class="height-input-container" nz-tooltip [nzTooltipTitle]="getAttributes('prospectiveDR')?.tooltip || ''" nzTooltipPlacement="topRight">
                      <div style="flex: 1;">
                        <input nz-input [id]="'pdrFirstName' + sectionName" [value]="infoForm.get('pdrFirstName')?.value"
                          [disabled]="true" placeholder="First Name" [attr.aria-label]="'First Name'" />
                      </div>
                      <div style="flex: 1;">
                        <input nz-input [id]="'pdrLastName' + sectionName" [value]="infoForm.get('pdrLastName')?.value"
                          [disabled]="true" placeholder="Last Name" [attr.aria-label]="'Last Name'" />
                      </div>
                      <div style="flex: 1;">
                        <ppl-dropdown-select [id]="'pdrRelation' + sectionName"
                          placeholder="Relationship" [options]="relationshipOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                          [ngModel]="infoForm.get('pdrRelation')?.value" [ngModelOptions]="{standalone: true}"
                          [attr.aria-label]="'Relationship'" [disabled]="true">
                        </ppl-dropdown-select>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
            }
            @if(isAttrAvailable('prospectiveDR') && entry !== 'referral' && entry !== 'participantEnrollment'){
              <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR" class="ppl-form-label">{{getAttributes('prospectiveDR').label}}</nz-form-label>
                  <nz-form-control class="ppl-form-control">
                    <span>{{ getProspectiveDRDisplayValue(filledInfo) }}</span>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
            }
  </form>
</div>
<div class="custom-row">
  <ppl-button 
  label="Cancel" 
  icon="fa fa-ban" 
  [customClass]="'alt-button'" 
  [iconPosition]="'left'"
  (click)="cancelEdit()"
  ></ppl-button>    

  <ppl-button 
  label="Save" 
  icon="fa fa-floppy-o" 
  [customClass]="'alt-button'" 
  [iconPosition]="'left'"
  (click)="save()"
  ></ppl-button>
</div>
} @else if(mode==="read" && savedData && secData){
  <div tabIndex="0">
<div nz-row>
  @if(isAttrAvailable('businessName')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'businessName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
          {{ getAttributes("businessName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.businessName }}
          </span>
          <span *ngIf="!savedData.businessName" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
  @if(isAttrAvailable('fname')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'fname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
        {{ getAttributes("fname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.fname }}
        </span>
        <span *ngIf="!savedData.fname" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  } @if(isAttrAvailable('mname')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'mname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("mname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.mname }}
        </span>
        <span *ngIf="!savedData.mname" class="sr-only">Blank</span>
      </div>
    </div>
  </div>

  } @if(isAttrAvailable('lname')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'lname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("lname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.lname }}
        </span>
        <span *ngIf="!savedData.lname" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  } @if(isAttrAvailable('maiden_name')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'maiden_name']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("maiden_name").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.maiden_name }}
        </span>
        <span *ngIf="!savedData.maiden_name" class="sr-only">Blank</span>
      </div>
    </div>
  </div>

  } @if(isAttrAvailable('dob')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'dob']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("dob").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.dob | date : "MM/dd/yyyy"}}
        </span>
        <span *ngIf="!savedData.dob" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  } @if(isAttrAvailable('gender')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'gender']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("gender").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData['gender'] ? getLookupValue(genderList,savedData['gender']) : savedData['gender']}}
        </span>
        <span *ngIf="!savedData.gender" class="sr-only">Blank</span>
      </div>
    </div>
  </div>

  }@if(isAttrAvailable('state')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'state']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("state").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData.state ? getLookupValue(statesList, savedData.state) : savedData.state}}
        </span>
        <span *ngIf="!savedData.state" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('relationToParticipant')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'relationToParticipant']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("relationToParticipant").label }}
          </div>          
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ savedData.relationToParticipant ? getLookupValue(relationshipOptions, savedData['relationToParticipant']) : savedData.relationToParticipant}}
            </span>
            <span *ngIf="!savedData.relationToParticipant" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    }
    @if(isAttrAvailable('tempProtectedSts')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
      *authorizeFieldView="[pageId, tabId, 'Demographics', 'tempProtectedSts']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("tempProtectedSts").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.tempProtectedSts }}
          </span>
          <span *ngIf="!savedData.tempProtectedSts" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
    @if(savedData.tempProtectedSts === 'Yes') {
    @if(isAttrAvailable('tpsCountryLkp')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
      *authorizeFieldView="[pageId, tabId, 'Demographics', 'tpsCountryLkp']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("tpsCountryLkp").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.tpsCountryLkp ? getLookupValue(tpsCountries, savedData['tpsCountryLkp']) :
            savedData.tpsCountryLkp}}
          </span>
          <span *ngIf="!savedData.tpsCountryLkp" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
    }
  @if(isAttrAvailable('waiver')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'waiver']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("waiver").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData['waiver'] ? getLookupValue(waiver,savedData['waiver']) : savedData['waiver']}}
          </span>
          <span *ngIf="!savedData.waiver" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
  }
  @if(isAttrAvailable('ldssOffice')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'ldssOffice']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("ldssOffice").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData['ldssOffice'] ? getLookupValue(ldssOfficeValues, savedData['ldssOffice']) : savedData['ldssOffice']}}
          </span>
          <span *ngIf="!savedData.ldssOffice" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
  }
  @if(isAttrAvailable('mcoOrgName')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'mcoOrgName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("mcoOrgName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.mcoOrgName }}
          </span>
          <span *ngIf="!savedData.mcoOrgName" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
  
    }
    @if(isAttrAvailable('currentFI')){

      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'currentFI']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("currentFI").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
             <span>
              {{ savedData['currentFI'] ? getLookupValue(currentFIValues, savedData['currentFI']) : savedData['currentFI']}}
            </span>
            <span *ngIf="!savedData.currentFI" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    }
    @if(isAttrAvailable('fiOrgName')){
  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'fiOrgName']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("fiOrgName").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ savedData.fiOrgName }}
            </span>
            <span *ngIf="!savedData.fiOrgName" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    
      }
  @if(isAttrAvailable('eligiblityStartDate')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eligiblityStartDate']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("eligiblityStartDate").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.eligiblityStartDate | date : "MM/dd/yyyy"}}
          </span>
          <span *ngIf="!savedData.eligiblityStartDate" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
  @if(isAttrAvailable('eligiblityEndDate')){

    <div nz-col nzSpan="12"  [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eligiblityEndDate']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("eligiblityEndDate").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
          <span>
            {{ savedData.eligiblityEndDate | date : "MM/dd/yyyy"}}
          </span>
          <span *ngIf="!savedData.eligiblityEndDate" class="sr-only">Blank</span>
        </div>
      </div>
    </div>
    }
    @if(isAttrAvailable('contactStsReasonLkp')){
  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'contactStsReasonLkp']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("contactStsReasonLkp").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
            {{ savedData.contactStsReasonLkp ? getLookupValue(contactStsReasonLkpList, savedData['contactStsReasonLkp']) : savedData.contactStsReasonLkp}}
            </span>
            <span *ngIf="!savedData.contactStsReasonLkp" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    
      }
      @if(isAttrAvailable('contactStsComments')){
  
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'contactStsComments']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("contactStsComments").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
              <span>
                {{ savedData.contactStsComments }}
              </span>
              <span *ngIf="!savedData.contactStsComments" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
      }
      @if(isAttrAvailable('prospectiveDR')){
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'prospectiveDR']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("prospectiveDR").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
              <span>
                {{ getProspectiveDRDisplayValue(savedData) }}
              </span>
              <span *ngIf="!getProspectiveDRDisplayValue(savedData)" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
      }
      @if(isAttrAvailable('dupsReason') && (savedData.applicationStatus === 'Review Complete' || savedData.applicationStatus === 'Review Needed') && savedData.dupsReason){
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'dupsReason']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("dupsReason").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
              <span class="error-message">
                {{ savedData.dupsReason }}
              </span>
              <span *ngIf="!savedData.dupsReason" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
      }
</div>
@if(isAttrAvailable('nonProfitStatus')){
  <div nz-row>
    <div nz-col nzSpan="8" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" ngClass="font-weight-600 pt-2">
      {{ getAttributes("nonProfitStatus").label }}
    </div>
  </div>
  <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'taxExempt']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("taxExempt").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing"> 
            <span>
              {{ savedData.taxExempt ? getLookupValue(taxExemptOptions, savedData['taxExempt']) : savedData.taxExempt}}
            </span>
            <span *ngIf="!savedData.taxExempt" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"  *authorizeFieldView="[pageId, tabId, 'Demographics', 'nprftDocumentationReceived']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("nprftDocumentationReceived").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ savedData.nprftDocumentationReceived }}
            </span>
            <span *ngIf="!savedData.nprftDocumentationReceived" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    </div>
  }

@if(isAttrAvailable('isShowOnDirectory')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'isShowOnDirectory']">
    <div nz-row>
      <div nz-col nzSpan="10" ngClass="font-weight-600 pt-2">
        {{getAttributes('isShowOnDirectory').label}}
      </div>
      <div nz-col nzSpan="8" ngClass="pt-2"> 
        <span>
          {{filledInfo.isShowOnDirectory === true ? 'Yes' : 'No'}}
        </span>
        <span *ngIf="savedData.isShowOnDirectory === null || savedData.isShowOnDirectory === undefined" class="sr-only">
          Blank
        </span>
      </div>
    </div>
  </div>
}

@if(isAttrAvailable('isProvidingServices')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'isProvidingServices']">
    <div nz-row>
      <div nz-col nzSpan="10" ngClass="font-weight-600 pt-2">
        {{getAttributes('isProvidingServices').label}}
      </div>
      <div nz-col nzSpan="8" ngClass="pt-2"> 
        <span>
          {{filledInfo.isProvidingServices !== null ? (filledInfo.isProvidingServices === true ? 'Yes' : 'No') : '' }}
        </span>
        <span *ngIf="filledInfo.isProvidingServices === null || filledInfo.isProvidingServices === undefined" class="sr-only">
          Blank
        </span>
      </div>
    </div>
  </div>
}

@if(isAttrAvailable('registerPref')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'registerPref']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("registerPref").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{ savedData['registerPref'] ? getLookupValue(prefList, savedData['registerPref']) : savedData['registerPref']}}
        </span>
        <span *ngIf="!savedData.registerPref" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
}
@if(isAttrAvailable('yearsInState')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'yearsInState']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("yearsInState").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
        <span>
          {{savedData['yearsInState']}}
        </span>
        <span *ngIf="!savedData['yearsInState']" class="sr-only">Blank</span>
      </div>
    </div>
  </div>
}

<div nz-row>
  @if(isAttrAvailable('race')){  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'race']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("race").label }}
          </div>          
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ savedData.race ? getLookupValue(raceOptions, savedData['race']) : savedData.race}}
            </span>
            <span *ngIf="!savedData.race" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    }
  @if(isAttrAvailable('height')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'height']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("height").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{(savedData.heightFeet || savedData.heightInches)? savedData.heightFeet + "'" + savedData.heightInches +"''" :savedData.heightFeet}}
            </span>
            <span *ngIf="!savedData.heightFeet" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    }
    @if(isAttrAvailable('weight')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'weight']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("weight").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{savedData.weight}}
            </span>
            <span *ngIf="!savedData.weight" class="sr-only">Blank</span>
        </div>
      </div>
      </div>
      }
      @if(isAttrAvailable('eyeColor')){
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eyeColor']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("eyeColor").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
              <span>
                {{ getLookupValue(eyeColors, savedData['eyeColor']) || savedData.eyeColor}}
              </span>
              <span *ngIf="!savedData.eyeColor" class="sr-only">Blank</span>
            </div>
          </div>
        </div>
      }
    @if(isAttrAvailable('hairColor')){

      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'hairColor']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("hairColor").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ getLookupValue(hairColors, savedData['hairColor']) || savedData.hairColor}}
            </span>
            <span *ngIf="!savedData.hairColor" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
    }
    @if(isAttrAvailable('birthPlace')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'birthPlace']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("birthPlace").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">
            <span>
              {{ savedData.birthCity}} {{(savedData.birthState? " , "+ savedData.birthState :savedData.birthState) }} {{(savedData.birthCountry?" , " +savedData.birthCountry: savedData.birthCountry)}}
            </span>
            <span *ngIf="!savedData.birthCity" class="sr-only">Blank</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
} @else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}